module.exports = __webpack_public_path__ + "img/dumplings.353c5578.png";